import { ChartRef } from '../types/refs';
import { ChartAxis } from '../types/axis';
import { AxisOptions } from '../types/series-options';


export function yAxis<TRow extends object>(ref: ChartRef<TRow>,
                                           options: AxisOptions): ChartAxis {
  const yAxis = {
    ...options,
    name: 'y'
  }
  ref.createAxis(yAxis);
  return yAxis;
}
